import { render, staticRenderFns } from "./solution-slider.vue?vue&type=template&id=33013a8a"
import script from "./solution-slider.vue?vue&type=script&lang=js"
export * from "./solution-slider.vue?vue&type=script&lang=js"
import style0 from "./solution-slider.vue?vue&type=style&index=0&id=33013a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports